import { c as _c } from "react/compiler-runtime";
import type { EntityOnboarding } from '@onefootprint/request-types/dashboard';
import { LoadingSpinner } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import useOnboardingKindText from '@/hooks/use-onboarding-kind-text';
import useStatusText from '@/hooks/use-status-text';
import { getStatusColor, getTimestampText, isAutomaticCheckOnboarding, onboardingHasPlaybook } from '../../utils';
type OnboardingTabLabelProps = {
  onboarding: EntityOnboarding;
};
const OnboardingTabLabel = t0 => {
  const $ = _c(22);
  const {
    onboarding
  } = t0;
  const statusT = useStatusText();
  const onboardingKindT = useOnboardingKindText();
  let t1;
  if ($[0] !== onboarding.status) {
    t1 = getStatusColor(onboarding.status);
    $[0] = onboarding.status;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const statusColor = t1;
  let t2;
  if ($[2] !== onboarding.timestamp) {
    t2 = getTimestampText(onboarding.timestamp);
    $[2] = onboarding.timestamp;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const timestampText = t2;
  const playbookName = onboardingHasPlaybook(onboarding) ? onboarding.playbook?.name : undefined;
  let t3;
  if ($[4] !== onboarding || $[5] !== statusColor || $[6] !== statusT) {
    t3 = () => {
      const statusTextClassName = cx("text-caption-3", {
        "text-success": statusColor === "success",
        "text-error": statusColor === "error",
        "text-tertiary": statusColor === "neutral"
      });
      if (onboarding.status === "pending" && !onboarding.deactivated) {
        return <div className="flex items-center gap-1.5"><LoadingSpinner size="compact" color="tertiary" /><div className={statusTextClassName}>{statusT(onboarding.status)}</div></div>;
      }
      if (isAutomaticCheckOnboarding(onboarding) && onboarding.status !== "error") {
        return null;
      }
      return <div className={statusTextClassName}>{statusT(onboarding.status)}</div>;
    };
    $[4] = onboarding;
    $[5] = statusColor;
    $[6] = statusT;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const renderStatus = t3;
  let t4;
  if ($[8] !== timestampText) {
    t4 = <p className="text-snippet-3 text-tertiary">{timestampText}</p>;
    $[8] = timestampText;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== renderStatus) {
    t5 = renderStatus();
    $[10] = renderStatus;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <div className="flex items-center justify-between">{t4}{t5}</div>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== onboarding.kind || $[16] !== onboardingKindT || $[17] !== playbookName) {
    t7 = playbookName ? <><div className="text-label-2 text-primary truncate" title={playbookName}>{playbookName}</div><div className="text-label-2 text-tertiary">{onboardingKindT(onboarding.kind)}</div></> : <div className="text-label-2 text-primary">{onboardingKindT(onboarding.kind)}</div>;
    $[15] = onboarding.kind;
    $[16] = onboardingKindT;
    $[17] = playbookName;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t6 || $[20] !== t7) {
    t8 = <div className="flex flex-col gap-1 text-left">{t6}{t7}</div>;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
};
export default OnboardingTabLabel;